/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AiExtractionId
 */
export interface AiExtractionId {
}

/**
 * Check if a given object implements the AiExtractionId interface.
 */
export function instanceOfAiExtractionId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AiExtractionIdFromJSON(json: any): AiExtractionId {
    return AiExtractionIdFromJSONTyped(json, false);
}

export function AiExtractionIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiExtractionId {
    return json;
}

export function AiExtractionIdToJSON(value?: AiExtractionId | null): any {
    return value;
}

